module.exports = __webpack_public_path__ + "img/sur.788f3e2a.svg";